module.exports = __webpack_public_path__ + "img/item-7.6ba50900.png";